import { Dropdown as InnerDropdown, DropdownMenuItem, DropdownMenu } from './dropdown';
import { SubMenu } from '../menu/menu';
const Dropdown = InnerDropdown;
Dropdown.Item = DropdownMenuItem;
Dropdown.SubMenu = SubMenu;
Dropdown.Menu = DropdownMenu;
export default Dropdown;
